declare const $cz: any;
const config: { [label: string]: any } = (window as any).stemplateConfig || {};
let isShare = false;
$cz.setup("afterLoad", () => {
  // 分享只加载一次
  if (isShare) {
    return;
  } else {
    isShare = true;
  }
  if (!config.tenantId) {
    return;
  }
  (window as any).$swxsdk.initWxSdk(
    { tenantId: config.tenantId },
    (window as any).$sk.config.apiUrl
  );
  (window as any).$swxsdk.on("sharer", {
    title: config.shareTitle,
    desc: config.shareDesc,
    link: window.location.href,
    imgUrl: "https:" + config.shareCoverUrl,
  });
  (window as any).$swxsdk.on("sharer_friends", {
    title: config.shareTitle,
    desc: config.shareDesc,
    link: window.location.href,
    imgUrl: "https:" + config.shareCoverUrl,
  });
});
